export default __webpack_public_path__ + "static/media/cardonzo2.ef8b0f36.jpg";